// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Modal,
//   Box,
//   Table,
//   CircularProgress,
//   LinearProgress,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import nopdf from "../../../assets/images/nopdf.png";
// import dayjs from "dayjs";
// import moment from "moment";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import AiIcon from "@mui/icons-material/Psychology";

// import logo from "../../../assets/images/qq.png"; // If you have this

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "80vw",
//   height: "85vh",
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: "10px",
//   overflowY: "auto",
// };

// type Props = {};

// interface SelectOption {
//   value: string | number;
//   label: string;
// }

// // AI Detection Logic (Kept exactly same)
// const simulateAIDocumentTypeDetection = async (
//   _base64Pdf: string,
//   currentFileName: string,
//   t: any,
// ): Promise<string | null> => {
//   return new Promise((resolve) => {
//     const contentToAnalyze = currentFileName
//       .toLowerCase()
//       .replace(/[_-]/g, " ");
//     setTimeout(() => {
//       let detectedTypeLabel: string | null = null;
//       resolve(detectedTypeLabel);
//     }, 1500);
//   });
// };



// const isValidFileType = (file: File): boolean => {
//   // Only allow PDF MIME types
//   const allowedMimeTypes = ["application/pdf"];

//   // Only allow PDF extensions
//   const allowedExtensions = [".pdf"];

//   // Get the file name
//   const fileName = file.name.toLowerCase();

//   // Check if the file extension is .pdf
//   const fileExtension = fileName.substring(fileName.lastIndexOf("."));
//   if (!allowedExtensions.includes(fileExtension)) {
//     console.log("Rejected: Invalid file extension");
//     return false;
//   }

//   // Check if MIME type is allowed (only PDF)
//   if (!allowedMimeTypes.includes(file.type)) {
//     console.log("Rejected: Invalid MIME type");
//     return false;
//   }

//   // Check for dangerous double extensions
//   const fileNameParts = fileName.split(".");

//   if (fileNameParts.length > 2) {
//     const secondLastPart = fileNameParts[fileNameParts.length - 2];

//     const dangerousExtensions = [
//       "exe",
//       "bat",
//       "cmd",
//       "sh",
//       "msi",
//       "dll",
//       "vbs",
//       "js",
//       "jar",
//       "py",
//       "rb",
//       "php",
//       "asp",
//     ];

//     if (dangerousExtensions.includes(secondLastPart)) {
//       console.log("Rejected: Dangerous double extension detected");
//       return false;
//     }

//     if (secondLastPart.length <= 5 && /^[a-zA-Z0-9]+$/.test(secondLastPart)) {
//       const commonWords = [
//         "fine",
//         "payer",
//         "file",
//         "name",
//         "test",
//         "data",
//         "info",
//         "main",
//         "part",
//         "draft",
//         "final",
//       ];
//       if (!commonWords.includes(secondLastPart)) {
//         console.log("Rejected: Suspicious double extension pattern");
//         return false;
//       }
//     }
//   }

//   // Additional check for executable files disguised as PDFs
//   if (
//     file.type === "application/x-msdownload" ||
//     file.type === "application/x-dosexec" ||
//     file.type === "application/x-executable"
//   ) {
//     console.log("Rejected: Executable file detected");
//     return false;
//   }

//   return true;
// };

// const DocumentEntryEdit = (props: Props) => {
//   const today = moment().format("YYYY-MM-DD");
//   const { t } = useTranslation();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
//   const [Subject, setSubject] = useState<SelectOption[]>([]);
//   const [Division, setDivision] = useState<SelectOption[]>([]);
//   const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]); // New State

//   const [Opens, setOpen] = React.useState(false);
//   const [Img, setImg] = useState<any>("");
//   const [loader, setLoader] = useState(false);

//   const [tableData, setTableData] = useState<any>([]);
//   const [pDate, setPDate] = useState(today || "");
//   const [keywords, setKeywords] = useState("");
//   const [fileName, setfileName] = useState("");
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
//   const [originalExtension, setOriginalExtension] = useState("");
//   const [isDetectingAttachmentType, setIsDetectingAttachmentType] =
//     useState(false);
//   const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] =
//     useState<string | null>(null);

//   const handlePanClose1 = () => setOpen(false);
//   const modalOpenHandle1 = (event: any) => {
//     setOpen(true);
//     setImg(event);
//   };

//   useEffect(() => {
//     getDocManagerbyID();
//     getFileType();
//     getSubject();
//     getDivision();
//     // Load sub-departments if initial division exists
//     if (location.state.divisionid) {
//       getSubDepartment(Number(location.state.divisionid));
//     }
//   }, []);

//   const getSubDepartment = (deptId: number = -1) => {
//     axios
//       .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, {
//         subDeptID: -1,
//         deptID: deptId,
//       })
//       .then((res) => {
//         const arr =
//           res.data.data.map((item: any) => ({
//             label: item.subDeptName,
//             value: String(item.subDeptID),
//           })) || [];
//         setSubDepartments(arr);
//       });
//   };

//   const getDocManagerbyID = async () => {
//     const collectData = {
//       docMid: location.state.docMid,
//       fileTypId: -1,
//       divisionid: -1,
//       subsubjId: -1,
//       subDeptID: -1,
//       user_Id: -1,
//       fileNo: "",
//       complt: "",
//     };
//     await axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
//       .then((res) => {
//         if (res.data.data?.length > 0) {
//           const files = res.data.data[0]["member_DocFiles"];
//           const arrtabledata = files?.map((item: any, index: number) => ({
//             id: index + 1,
//             pdFid: item["pdFid"] || "",
//             pdfName: item["pdfName"] || "",
//             docMid: item["docMid"] || "",
//             keywords: item["keywords"] || "",
//             subFtype: item["subFtype"] || "",
//             pDate: moment(item["pDate"] || "").format("YYYY-MM-DD"),
//             isMain: item["isMain"] || "",
//             entryDate: item["entryDate"] || "",
//             user_id: item["user_id"] || "",
//             pdfPath: item["pdfPath"] || "",
//             pdfView: item["pdfPath"] || "",
//             srn: -1,
//             isDelete: item["isDelete"] || "",
//           }));
//           setTableData(arrtabledata);
//         }
//       });
//   };

//   const getFileType = () => {
//     axios
//       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, {
//         docID: -1,
//         parentDocId: -1,
//         userId: "",
//       })
//       .then((res) => {
//         setTypeOption(
//           res?.data?.data?.map((item: any) => ({
//             label: item.doc_Name,
//             value: String(item.docID),
//           })) || [],
//         );
//       });
//   };

//   const getSubject = () => {
//     axios
//       .post(HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`, {
//         sID: -1,
//       })
//       .then((res) => {
//         setSubject(
//           res.data.data.map((item: any) => ({
//             label: item.subject,
//             value: String(item.sId),
//           })) || [],
//         );
//       });
//   };

//   const getDivision = () => {
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, {
//         id: -1,
//         nodeID: -1,
//         titleID: -1,
//       })
//       .then((res) => {
//         setDivision(
//           res.data.data.map((item: any) => ({
//             label: item.name,
//             value: String(item.id),
//           })) || [],
//         );
//       });
//   };

//   const getAutocompleteValue = (
//     options: SelectOption[],
//     formikValue: string | null | number,
//   ): SelectOption | null => {
//     if (formikValue === null || formikValue === undefined) return null;
//     return (
//       options.find((option) => String(option.value) === String(formikValue)) ||
//       null
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       docMid: location.state.docMid,
//       fileDef: location.state.fileDef,
//       fileNo: location.state.fileNo,
//       synopsis: location.state.synopsis,
//       fDate: dayjs(location.state.fDate).format("YYYY-MM-DD"),
//       perFr: dayjs(location.state.perFr).format("YYYY-MM-DD"),
//       perUt: dayjs(location.state.perUt).format("YYYY-MM-DD"),
//       authPersn: location.state.authPersn,
//       fileTypId: String(location.state.fileTypId),
//       subsubjId: String(location.state.subsubjId),
//       divisionid: String(location.state.divisionid),
//       subDeptID: String(location.state.subDeptID || ""), // Added subDeptID
//       user_Id: location.state.user_Id,
//       member_DocFiles: [],
//     },
//     validationSchema: Yup.object({
//       fileNo: Yup.string().required(t("text.reqFileNo")),
//     }),
//     onSubmit: async (values) => {
//       setLoader(true);
//       const submissionData = { ...values, member_DocFiles: tableData };
//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
//         submissionData,
//       );
//       if (response.data.isSuccess) {
//         toast.success(response.data.mesg);
//         setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
//       } else {
//         toast.error(response.data.mesg);
//       }
//       setLoader(false);
//     },
//   });

//   const onTransctionChange = async (
//     event: React.ChangeEvent<HTMLInputElement>,
//   ) => {
//     if (event.target.files && event.target.files[0]) {
//       const file = event.target.files[0];
//       const fileName = file.name;

//       // First validate the file
//       if (!isValidFileType(file)) {
//         toast.error(
//           t("text.invalidFileType", "Only valid PDF files are allowed"),
//         );
//         event.target.value = ""; // Reset the file input
//         return;
//       }

//       const currentFileName = file.name;
//       const extIndex = currentFileName.lastIndexOf(".");
//       const withoutExt =
//         extIndex !== -1
//           ? currentFileName.substring(0, extIndex)
//           : currentFileName;
//       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : "";

//       // Ensure extension is .pdf
//       if (ext.toLowerCase() !== ".pdf") {
//         toast.error(t("text.onlyPdfAllowed", "Only PDF files are allowed"));
//         event.target.value = "";
//         return;
//       }

//       setFileNameWithoutExt(withoutExt);
//       setOriginalExtension(ext);
//       setPreviewUrl(URL.createObjectURL(file));
//       setfileName(currentFileName);
//       setCurrentAttachmentAiSuggestion(null);
//       setIsDetectingAttachmentType(true);

//       try {
//         // Optional: Add AI detection if you have it
//         // const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
//         // setCurrentAttachmentAiSuggestion(detectedLabel);
//         setTimeout(() => setIsDetectingAttachmentType(false), 1500);
//       } catch (aiError) {
//         console.error("AI attachment category detection error:", aiError);
//         setIsDetectingAttachmentType(false);
//       }
//     } else {
//       // When no file is selected (user cancelled), reset everything
//       setfileName("");
//       setPreviewUrl("");
//       setFileNameWithoutExt("");
//       setOriginalExtension("");
//       setIsDetectingAttachmentType(false);
//       setCurrentAttachmentAiSuggestion(null);

//       // Ensure the input is cleared
//       event.target.value = "";
//     }
//   };
//   // const onTransctionChange = async (event: any) => {
//   //   if (event.target.files && event.target.files[0]) {
//   //     const file = event.target.files[0];
//   //     if (!isValidFileType(file)) { toast.error(t("text.invalidFileType")); return; }
//   //     const currentFileName = file.name;
//   //     const extIndex = currentFileName.lastIndexOf('.');
//   //     setFileNameWithoutExt(extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName);
//   //     setOriginalExtension(extIndex !== -1 ? currentFileName.substring(extIndex) : '');
//   //     setPreviewUrl(URL.createObjectURL(file));
//   //     setfileName(currentFileName);
//   //   }
//   // };

//   const addMoreRow = () => {
//     if (!fileName || !pDate) {
//       toast.warn(t("text.PleaseFillAttachmentDetails"));
//       return;
//     }

//     const newRow = {
//       id: tableData.length + 1,
//       pdFid: -1,
//       pdfName: fileName,
//       keywords: keywords,
//       pDate: pDate,
//       pdfView: previewUrl,
//       isDelete: false,
//     };

//     setTableData([...tableData, newRow]);

//     // Reset all file-related states
//     setfileName("");
//     setPreviewUrl("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setKeywords("");
//     setPDate(today || "");
//     setCurrentAttachmentAiSuggestion(null);

//     // Reset the file input element
//     const fileInput = document.getElementById(
//       "pdf_attach_file_input_edit",
//     ) as HTMLInputElement;
//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };
//   const removeExtraRow = (id: any) => {
//     setTableData(tableData.filter((row: any) => row.id !== id));
//   };
//   const handleReset = () => {
//     formik.resetForm();
//     setfileName("");
//     setPreviewUrl("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setKeywords("");
//     setPDate(today || "");
//     setCurrentAttachmentAiSuggestion(null);
//     setIsDetectingAttachmentType(false);
//     setTableData([]); // Clear table data if needed

//     // Reset the file input element
//     const fileInput = document.getElementById(
//       "pdf_attach_file_input_edit",
//     ) as HTMLInputElement;
//     if (fileInput) {
//       fileInput.value = "";
//     }

//     // Reset any other file inputs if they exist
//     const fileInputs = document.querySelectorAll('input[type="file"]');
//     fileInputs.forEach((input: any) => {
//       input.value = "";
//     });

//     // Reload original data
//     getDocManagerbyID();
//   };

//   const getPdfSource = (row: any) => row.pdfView || "";

//   return (
//     <div>
//       <ToastApp />
//       <div
//         style={{
//           padding: "10px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "3vh",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.DocumentEntryEdit")}
//           </Typography>
//           <Button
//             onClick={() => navigate(-1)}
//             variant="contained"
//             style={{
//               marginBottom: 15,
//               backgroundColor: `var(--header-background)`,
//             }}
//           >
//             <ArrowBackSharpIcon />
//           </Button>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={2}>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileNo"
//                   name="fileNo"
//                   label={t("text.EnterFileNo")}
//                   value={formik.values.fileNo}
//                   onChange={formik.handleChange}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="synopsis"
//                   name="synopsis"
//                   label={t("text.FileName")}
//                   value={formik.values.synopsis}
//                   onChange={formik.handleChange}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileDef"
//                   name="fileDef"
//                   label={t("text.EnterFileDef")}
//                   value={formik.values.fileDef}
//                   onChange={formik.handleChange}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perFr"
//                   name="perFr"
//                   label={t("text.EnterPeriodFileFrom")}
//                   value={formik.values.perFr}
//                   onChange={formik.handleChange}
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perUt"
//                   name="perUt"
//                   label={t("text.EnterPeriodFileUpto")}
//                   value={formik.values.perUt}
//                   onChange={formik.handleChange}
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="authPersn"
//                   name="authPersn"
//                   label={t("text.EnterAuthenticatePerson")}
//                   value={formik.values.authPersn}
//                   onChange={formik.handleChange}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fDate"
//                   name="fDate"
//                   label={t("text.EnterFileDate")}
//                   value={formik.values.fDate}
//                   onChange={formik.handleChange}
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>

//               {/* Autocomplete Fields */}
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   options={TypeOption}
//                   value={getAutocompleteValue(
//                     TypeOption,
//                     formik.values.fileTypId,
//                   )}
//                   getOptionLabel={(o) => o.label}
//                   onChange={(e, v) =>
//                     formik.setFieldValue(
//                       "fileTypId",
//                       v ? String(v.value) : null,
//                     )
//                   }
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField {...params} label={t("text.SelectFile")} />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   options={Subject}
//                   value={getAutocompleteValue(Subject, formik.values.subsubjId)}
//                   getOptionLabel={(o) => o.label}
//                   onChange={(e, v) =>
//                     formik.setFieldValue(
//                       "subsubjId",
//                       v ? String(v.value) : null,
//                     )
//                   }
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField {...params} label={t("text.SelectSubject")} />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   options={Division}
//                   value={getAutocompleteValue(
//                     Division,
//                     formik.values.divisionid,
//                   )}
//                   getOptionLabel={(o) => o.label}
//                   onChange={(e, v) => {
//                     formik.setFieldValue(
//                       "divisionid",
//                       v ? String(v.value) : null,
//                     );
//                     formik.setFieldValue("subDeptID", null); // Reset sub-department
//                     if (v) getSubDepartment(Number(v.value));
//                   }}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField {...params} label={t("text.SelectDepartment")} />
//                   )}
//                 />
//               </Grid>

//               {/* New Subdepartment Field */}
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   options={subDepartments}
//                   value={getAutocompleteValue(
//                     subDepartments,
//                     formik.values.subDeptID,
//                   )}
//                   getOptionLabel={(o) => o.label}
//                   onChange={(e, v) =>
//                     formik.setFieldValue(
//                       "subDeptID",
//                       v ? String(v.value) : null,
//                     )
//                   }
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={t("text.SelectSubDept", "Select Sub Department")}
//                     />
//                   )}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Divider sx={{ my: 2 }}>
//                   <Typography variant="subtitle1">
//                     {t("text.Attachments")}
//                   </Typography>
//                 </Divider>
//               </Grid>

//               <Grid item container spacing={2}>
//                 <Grid item lg={2.5} xs={12}>
//                   <TextField
//                     label={t("text.PeriodDate")}
//                     value={pDate}
//                     onChange={(e) => setPDate(e.target.value)}
//                     type="date"
//                     InputLabelProps={{ shrink: true }}
//                     size="small"
//                     fullWidth
//                   />
//                 </Grid>

//                 <Grid item lg={2.5} xs={12}>
//                   <TextField
//                     label={t("text.Keywords")}
//                     value={keywords}
//                     onChange={(e) => setKeywords(e.target.value)}
//                     size="small"
//                     fullWidth
//                   />
//                 </Grid>

//                 <Grid item lg={3} xs={12}>
//                   <TextField
//                     id="pdf_attach_file_input_edit"
//                     name="pdf_attach_input"
//                     label={t("text.AttachedFile", "Attach File")}
//                     onChange={onTransctionChange}
//                     size="small"
//                     type="file"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     inputProps={{
//                       accept: ".pdf,application/pdf" // Only accept PDF files
//                     }}
//                   />
//                   <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
//                     {t("text.allowedFileTypes", "Only PDF files are allowed")}
//                   </Typography>
//                   {isDetectingAttachmentType && fileName && (
//                     <Box sx={{ width: '100%', mt: 0.5 }}>
//                       <LinearProgress variant="indeterminate" />
//                       <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
//                         {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Grid>

//                 <Grid item lg={2.5} xs={12}>
//                   <TextField
//                     id="fileName_display_edit"
//                     name="fileName_display"
//                     label={t("text.EnterFileName", "Selected File")}
//                     value={fileNameWithoutExt}
//                     onChange={(e) => {
//                       let input = e.target.value.trim();
//                       const forcedExt = ".pdf";
//                       setFileNameWithoutExt(input);
//                       setOriginalExtension(forcedExt);
//                       setfileName(input + forcedExt);
//                     }}
//                     size="small"
//                     fullWidth
//                     InputProps={{
//                       endAdornment: originalExtension ? (
//                         <InputAdornment
//                           position="end"
//                           disableTypography
//                           sx={{
//                             pointerEvents: "none",
//                             userSelect: "none",
//                             color: "green",
//                             fontWeight: "bold"
//                           }}
//                         >
//                           {originalExtension}
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                     InputLabelProps={{
//                       shrink: Boolean(fileNameWithoutExt || originalExtension),
//                     }}
//                     error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
//                     helperText={
//                       fileName && !fileName.toLowerCase().endsWith(".pdf")
//                         ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
//                         : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
//                     }
//                   />
//                 </Grid>

//                 <Grid item lg={1.5} xs={12}>
//                   <Button
//                     startIcon={<AddCircleIcon />}
//                     variant="contained"
//                     fullWidth
//                     onClick={addMoreRow}
//                     disabled={!fileName || !pDate}
//                   >
//                     {t("text.add")}
//                   </Button>
//                 </Grid>
//               </Grid>
//               <Grid item xs={12}>
//                 {tableData.length > 0 && (
//                   <Grid item xs={12} sx={{ marginTop: "15px", overflowX: "auto" }}>
//                     <Table
//                       style={{
//                         borderCollapse: "collapse",
//                         width: "100%",
//                         border: "1px solid #ddd",
//                       }}
//                       size="small"
//                     >
//                       <thead style={{ backgroundColor: "#e0e0e0" }}>
//                         <tr>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.Action", "Action")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.PeriodDate", "Period Date")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.Keywords", "Keywords")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.FileName", "File Name")}
//                           </th>
//                           <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {t("text.PdfFile", "PDF File")}
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {tableData?.map((row: any) => (
//                           <tr key={row.id}>
//                             <td
//                               style={{
//                                 border: "1px solid #ddd",
//                                 padding: "8px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <DeleteIcon
//                                 style={{ color: "darkred", cursor: "pointer" }}
//                                 onClick={() => removeExtraRow(row.id)}
//                               />
//                             </td>
//                             <td
//                               style={{
//                                 border: "1px solid #ddd",
//                                 padding: "8px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {row.pDate ? moment(row.pDate).format("DD-MM-YYYY") : "-"}
//                             </td>
//                             <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                               {row.keywords || "-"}
//                             </td>
//                             <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                               {row.pdfName}
//                             </td>
//                             <td
//                               style={{
//                                 border: "1px solid #ddd",
//                                 padding: "8px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {row.pdfView ? (
//                                 <Typography
//                                   onClick={() => modalOpenHandle1(row.pdfView)}
//                                   sx={{
//                                     color: "primary.main",
//                                     cursor: "pointer",
//                                     textDecoration: "underline",
//                                   }}
//                                 >
//                                   {t("text.Preview", "Preview")}
//                                 </Typography>
//                               ) : (
//                                 t("text.NoPreview", "No Preview")
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </Grid>
//                 )}
//               </Grid>

//               <Grid
//                 item
//                 xs={12}
//                 container
//                 spacing={2}
//                 justifyContent="center"
//                 sx={{ mt: 2 }}
//               >
//                 <Grid item xs={6}>
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     fullWidth
//                     style={{ backgroundColor: `var(--header-background)` }}
//                   >
//                     {t("text.update")}
//                   </Button>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Button
//                     variant="contained"
//                     fullWidth
//                     style={{ backgroundColor: "#F43F5E" }}
//                     onClick={handleReset}
//                   >
//                     {t("text.reset")}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </form>

//           <Modal open={Opens} onClose={handlePanClose1}>
//             <Box sx={style}>
//               {Img ? (
//                 <embed
//                   src={Img}
//                   type="application/pdf"
//                   style={{ width: "100%", height: "100%" }}
//                 />
//               ) : (
//                 <img src={nopdf} style={{ width: "100%" }} />
//               )}
//             </Box>
//           </Modal>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default DocumentEntryEdit;



import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Table,
  CircularProgress,
  LinearProgress,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import nopdf from "../../../assets/images/nopdf.png";
import dayjs from "dayjs";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AiIcon from "@mui/icons-material/Psychology";

import logo from "../../../assets/images/qq.png"; // If you have this

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "85vh",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  overflowY: "auto",
};

type Props = {};

interface SelectOption {
  value: string | number;
  label: string;
}

// AI Detection Logic (Kept exactly same)
const simulateAIDocumentTypeDetection = async (
  _base64Pdf: string,
  currentFileName: string,
  t: any,
): Promise<string | null> => {
  return new Promise((resolve) => {
    const contentToAnalyze = currentFileName
      .toLowerCase()
      .replace(/[_-]/g, " ");
    setTimeout(() => {
      let detectedTypeLabel: string | null = null;
      resolve(detectedTypeLabel);
    }, 1500);
  });
};



const isValidFileType = (file: File): boolean => {
  // Only allow PDF MIME types
  const allowedMimeTypes = ["application/pdf"];

  // Only allow PDF extensions
  const allowedExtensions = [".pdf"];

  // Get the file name
  const fileName = file.name.toLowerCase();

  // Check if the file extension is .pdf
  const fileExtension = fileName.substring(fileName.lastIndexOf("."));
  if (!allowedExtensions.includes(fileExtension)) {
    console.log("Rejected: Invalid file extension");
    return false;
  }

  // Check if MIME type is allowed (only PDF)
  if (!allowedMimeTypes.includes(file.type)) {
    console.log("Rejected: Invalid MIME type");
    return false;
  }

  // Check for dangerous double extensions
  const fileNameParts = fileName.split(".");

  if (fileNameParts.length > 2) {
    const secondLastPart = fileNameParts[fileNameParts.length - 2];

    const dangerousExtensions = [
      "exe",
      "bat",
      "cmd",
      "sh",
      "msi",
      "dll",
      "vbs",
      "js",
      "jar",
      "py",
      "rb",
      "php",
      "asp",
    ];

    if (dangerousExtensions.includes(secondLastPart)) {
      console.log("Rejected: Dangerous double extension detected");
      return false;
    }

    if (secondLastPart.length <= 5 && /^[a-zA-Z0-9]+$/.test(secondLastPart)) {
      const commonWords = [
        "fine",
        "payer",
        "file",
        "name",
        "test",
        "data",
        "info",
        "main",
        "part",
        "draft",
        "final",
      ];
      if (!commonWords.includes(secondLastPart)) {
        console.log("Rejected: Suspicious double extension pattern");
        return false;
      }
    }
  }

  // Additional check for executable files disguised as PDFs
  if (
    file.type === "application/x-msdownload" ||
    file.type === "application/x-dosexec" ||
    file.type === "application/x-executable"
  ) {
    console.log("Rejected: Executable file detected");
    return false;
  }

  return true;
};

const DocumentEntryEdit = (props: Props) => {
  const today = moment().format("YYYY-MM-DD");
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
  const [Subject, setSubject] = useState<SelectOption[]>([]);
  const [Division, setDivision] = useState<SelectOption[]>([]);
  const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]); // New State

  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState<any>("");
  const [loader, setLoader] = useState(false);

  const [tableData, setTableData] = useState<any>([]);
  const [pDate, setPDate] = useState(today || "");
  const [keywords, setKeywords] = useState("");
  const [fileName, setfileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
  const [originalExtension, setOriginalExtension] = useState("");
  const [isDetectingAttachmentType, setIsDetectingAttachmentType] =
    useState(false);
  const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] =
    useState<string | null>(null);

  const handlePanClose1 = () => setOpen(false);
  const modalOpenHandle1 = (event: any) => {
    setOpen(true);
    setImg(event);
  };

  useEffect(() => {
    getDocManagerbyID();
    getFileType();
    getSubject();
    getDivision();
    // Load sub-departments if initial division exists
    if (location.state.divisionid) {
      getSubDepartment(Number(location.state.divisionid));
    }
  }, []);

  const getSubDepartment = (deptId: number = -1) => {
    axios
      .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, {
        subDeptID: -1,
        deptID: deptId,
      })
      .then((res) => {
        const arr =
          res.data.data.map((item: any) => ({
            label: item.subDeptName,
            value: String(item.subDeptID),
          })) || [];
        setSubDepartments(arr);
      });
  };

  const getDocManagerbyID = async () => {
    const collectData = {
      docMid: location.state.docMid,
      fileTypId: -1,
      divisionid: -1,
      subsubjId: -1,
      subDeptID: -1,
      user_Id: -1,
      fileNo: "",
      complt: "",
    };
    await axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
      .then((res) => {
        if (res.data.data?.length > 0) {
          const files = res.data.data[0]["member_DocFiles"];
          const arrtabledata = files?.map((item: any, index: number) => ({
            id: index + 1,
            pdFid: item["pdFid"] || "",
            pdfName: item["pdfName"] || "",
            docMid: item["docMid"] || "",
            keywords: item["keywords"] || "",
            subFtype: item["subFtype"] || "",
            pDate: moment(item["pDate"] || "").format("YYYY-MM-DD"),
            isMain: item["isMain"] || "",
            entryDate: item["entryDate"] || "",
            user_id: item["user_id"] || "",
            pdfPath: item["pdfPath"] || "",
            pdfView: item["pdfPath"] || "",
            srn: -1,
            isDelete: item["isDelete"] || "",
          }));
          setTableData(arrtabledata);
          // ✅ Set subDeptID from response if exists, otherwise null
          const subDeptIdFromData = res.data.data[0]["subDeptID"];
          if (subDeptIdFromData && subDeptIdFromData !== -1) {
            formik.setFieldValue("subDeptID", String(subDeptIdFromData));
          } else {
            formik.setFieldValue("subDeptID", null);
          }

          // ✅ Set user_Id from response
          const userIdFromData = res.data.data[0]["user_Id"];
          if (userIdFromData && userIdFromData !== -1) {
            formik.setFieldValue("user_Id", Number(userIdFromData));
          } else {
            formik.setFieldValue("user_Id", null);
          }
        }
      });
  };

  const getFileType = () => {
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, {
        docID: -1,
        parentDocId: -1,
        userId: "",
      })
      .then((res) => {
        setTypeOption(
          res?.data?.data?.map((item: any) => ({
            label: item.doc_Name,
            value: String(item.docID),
          })) || [],
        );
      });
  };

  const getSubject = () => {
    axios
      .post(HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`, {
        sID: -1,
      })
      .then((res) => {
        setSubject(
          res.data.data.map((item: any) => ({
            label: item.subject,
            value: String(item.sId),
          })) || [],
        );
      });
  };

  const getDivision = () => {
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, {
        id: -1,
        nodeID: -1,
        titleID: -1,
      })
      .then((res) => {
        setDivision(
          res.data.data.map((item: any) => ({
            label: item.name,
            value: String(item.id),
          })) || [],
        );
      });
  };

  const getAutocompleteValue = (
    options: SelectOption[],
    formikValue: string | null | number,
  ): SelectOption | null => {
    if (formikValue === null || formikValue === undefined) return null;
    return (
      options.find((option) => String(option.value) === String(formikValue)) ||
      null
    );
  };

  const formik = useFormik({
    initialValues: {
      docMid: location.state.docMid,
      fileDef: location.state.fileDef,
      fileNo: location.state.fileNo,
      synopsis: location.state.synopsis,
      fDate: dayjs(location.state.fDate).format("YYYY-MM-DD"),
      perFr: dayjs(location.state.perFr).format("YYYY-MM-DD"),
      perUt: dayjs(location.state.perUt).format("YYYY-MM-DD"),
      authPersn: location.state.authPersn,
      fileTypId: String(location.state.fileTypId),
      subsubjId: String(location.state.subsubjId),
      divisionid: String(location.state.divisionid),
      subDeptID: location.state.subDeptID ? String(location.state.subDeptID) : null,
      user_Id: location.state.user_Id ? Number(location.state.user_Id) : null,
      member_DocFiles: [],
    },
    validationSchema: Yup.object({
      fileNo: Yup.string().required(t("text.reqFileNo")),
    }),
    onSubmit: async (values) => {
      setLoader(true);
      // ✅ Sanitize member_DocFiles to ensure user_id is a number
      const sanitizedTableData = tableData.map((row: any) => ({
        ...row,
        user_id: row.user_id ? Number(row.user_id) : -1,
        pdFid: row.pdFid ? Number(row.pdFid) : -1,
        docMid: row.docMid ? Number(row.docMid) : -1,
      }));

      const submissionData = {
        ...values, member_DocFiles: tableData,
        subDeptID: values.subDeptID === "" || !values.subDeptID ? null : values.subDeptID,
        user_Id: values.user_Id ? Number(values.user_Id) : null,
      };

      const response = await axios.post(
        HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
        submissionData,
      );
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
      } else {
        toast.error(response.data.mesg);
      }
      setLoader(false);
    },
  });

  const onTransctionChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file.name;

      // First validate the file
      if (!isValidFileType(file)) {
        toast.error(
          t("text.invalidFileType", "Only valid PDF files are allowed"),
        );
        event.target.value = ""; // Reset the file input
        return;
      }

      const currentFileName = file.name;
      const extIndex = currentFileName.lastIndexOf(".");
      const withoutExt =
        extIndex !== -1
          ? currentFileName.substring(0, extIndex)
          : currentFileName;
      const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : "";

      // Ensure extension is .pdf
      if (ext.toLowerCase() !== ".pdf") {
        toast.error(t("text.onlyPdfAllowed", "Only PDF files are allowed"));
        event.target.value = "";
        return;
      }

      setFileNameWithoutExt(withoutExt);
      setOriginalExtension(ext);
      setPreviewUrl(URL.createObjectURL(file));
      setfileName(currentFileName);
      setCurrentAttachmentAiSuggestion(null);
      setIsDetectingAttachmentType(true);

      try {
        // Optional: Add AI detection if you have it
        // const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
        // setCurrentAttachmentAiSuggestion(detectedLabel);
        setTimeout(() => setIsDetectingAttachmentType(false), 1500);
      } catch (aiError) {
        console.error("AI attachment category detection error:", aiError);
        setIsDetectingAttachmentType(false);
      }
    } else {
      // When no file is selected (user cancelled), reset everything
      setfileName("");
      setPreviewUrl("");
      setFileNameWithoutExt("");
      setOriginalExtension("");
      setIsDetectingAttachmentType(false);
      setCurrentAttachmentAiSuggestion(null);

      // Ensure the input is cleared
      event.target.value = "";
    }
  };
  // const onTransctionChange = async (event: any) => {
  //   if (event.target.files && event.target.files[0]) {
  //     const file = event.target.files[0];
  //     if (!isValidFileType(file)) { toast.error(t("text.invalidFileType")); return; }
  //     const currentFileName = file.name;
  //     const extIndex = currentFileName.lastIndexOf('.');
  //     setFileNameWithoutExt(extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName);
  //     setOriginalExtension(extIndex !== -1 ? currentFileName.substring(extIndex) : '');
  //     setPreviewUrl(URL.createObjectURL(file));
  //     setfileName(currentFileName);
  //   }
  // };

  const addMoreRow = () => {
    if (!fileName || !pDate) {
      toast.warn(t("text.PleaseFillAttachmentDetails"));
      return;
    }

    const newRow = {
      id: tableData.length + 1,
      pdFid: -1,
      pdfName: fileName,
      keywords: keywords,
      pDate: pDate,
      pdfView: previewUrl,
      isDelete: false,
      user_id: formik.values.user_Id ? Number(formik.values.user_Id) : -1,
    };

    setTableData([...tableData, newRow]);

    // Reset all file-related states
    setfileName("");
    setPreviewUrl("");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setKeywords("");
    setPDate(today || "");
    setCurrentAttachmentAiSuggestion(null);

    // Reset the file input element
    const fileInput = document.getElementById(
      "pdf_attach_file_input_edit",
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const removeExtraRow = (id: any) => {
    setTableData(tableData.filter((row: any) => row.id !== id));
  };
  const handleReset = () => {
    formik.resetForm();
    setfileName("");
    setPreviewUrl("");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setKeywords("");
    setPDate(today || "");
    setCurrentAttachmentAiSuggestion(null);
    setIsDetectingAttachmentType(false);
    setTableData([]); // Clear table data if needed

    // ✅ Reset subDeptID to null
    formik.setFieldValue("subDeptID", null);
    // ✅ Reset user_Id to null or original value
    formik.setFieldValue("user_Id", location.state.user_Id ? Number(location.state.user_Id) : null);
    // Reset the file input element
    const fileInput = document.getElementById(
      "pdf_attach_file_input_edit",
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }

    // Reset any other file inputs if they exist
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input: any) => {
      input.value = "";
    });

    // Reload original data
    getDocManagerbyID();
  };

  const getPdfSource = (row: any) => row.pdfView || "";

  return (
    <div>
      <ToastApp />
      <div
        style={{
          padding: "10px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.DocumentEntryEdit")}
          </Typography>
          <Button
            onClick={() => navigate(-1)}
            variant="contained"
            style={{
              marginBottom: 15,
              backgroundColor: `var(--header-background)`,
            }}
          >
            <ArrowBackSharpIcon />
          </Button>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fileNo"
                  name="fileNo"
                  label={t("text.EnterFileNo")}
                  value={formik.values.fileNo}
                  onChange={formik.handleChange}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="synopsis"
                  name="synopsis"
                  label={t("text.EnterSynopsis")}
                  value={formik.values.synopsis}
                  onChange={formik.handleChange}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fileDef"
                  name="fileDef"
                  label={t("text.EnterFileDef")}
                  value={formik.values.fileDef}
                  onChange={formik.handleChange}
                  size="small"
                  fullWidth
                />
              </Grid>
              {/* <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="perFr"
                  name="perFr"
                  label={t("text.EnterPeriodFileFrom")}
                  value={formik.values.perFr}
                  onChange={formik.handleChange}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="perUt"
                  name="perUt"
                  label={t("text.EnterPeriodFileUpto")}
                  value={formik.values.perUt}
                  onChange={formik.handleChange}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid> */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="authPersn"
                  name="authPersn"
                  label={t("text.EnterAuthenticatePerson")}
                  value={formik.values.authPersn}
                  onChange={formik.handleChange}
                  size="small"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fDate"
                  name="fDate"
                  label={t("text.EnterFileDate")}
                  value={formik.values.fDate}
                  onChange={formik.handleChange}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                />
              </Grid>

              {/* Autocomplete Fields */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  options={TypeOption}
                  value={getAutocompleteValue(
                    TypeOption,
                    formik.values.fileTypId,
                  )}
                  getOptionLabel={(o) => o.label}
                  onChange={(e, v) =>
                    formik.setFieldValue(
                      "fileTypId",
                      v ? String(v.value) : null,
                    )
                  }
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFile")} />
                  )}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  options={Subject}
                  value={getAutocompleteValue(Subject, formik.values.subsubjId)}
                  getOptionLabel={(o) => o.label}
                  onChange={(e, v) =>
                    formik.setFieldValue(
                      "subsubjId",
                      v ? String(v.value) : null,
                    )
                  }
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectSubject")} />
                  )}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  options={Division}
                  value={getAutocompleteValue(
                    Division,
                    formik.values.divisionid,
                  )}
                  getOptionLabel={(o) => o.label}
                  onChange={(e, v) => {
                    formik.setFieldValue(
                      "divisionid",
                      v ? String(v.value) : null,
                    );
                    formik.setFieldValue("subDeptID", null); // Reset sub-department
                    if (v) getSubDepartment(Number(v.value));
                  }}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectDepartment")} />
                  )}
                />
              </Grid>

              {/* New Subdepartment Field */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  options={subDepartments}
                  value={getAutocompleteValue(
                    subDepartments,
                    formik.values.subDeptID,
                  )}
                  getOptionLabel={(o) => o.label}
                  onChange={(e, v) =>
                    formik.setFieldValue(
                      "subDeptID",
                      v ? String(v.value) : null,
                    )
                  }
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("text.SelectSubDept", "Select Sub Department")}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ my: 2 }}>
                  <Typography variant="subtitle1">
                    {t("text.Attachments")}
                  </Typography>
                </Divider>
              </Grid>

              <Grid item container spacing={2}>
                <Grid item lg={2.5} xs={12}>
                  <TextField
                    label={t("text.PeriodDate")}
                    value={pDate}
                    onChange={(e) => setPDate(e.target.value)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item lg={2.5} xs={12}>
                  <TextField
                    label={t("text.Keywords")}
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item lg={3} xs={12}>
                  <TextField
                    id="pdf_attach_file_input_edit"
                    name="pdf_attach_input"
                    label={t("text.AttachedFile", "Attach File")}
                    onChange={onTransctionChange}
                    size="small"
                    type="file"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      accept: ".pdf,application/pdf" // Only accept PDF files
                    }}
                  />
                  <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
                    {t("text.allowedFileTypes", "Only PDF files are allowed")}
                  </Typography>
                  {isDetectingAttachmentType && fileName && (
                    <Box sx={{ width: '100%', mt: 0.5 }}>
                      <LinearProgress variant="indeterminate" />
                      <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
                        {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
                      </Typography>
                    </Box>
                  )}
                </Grid>

                <Grid item lg={2.5} xs={12}>
                  <TextField
                    id="fileName_display_edit"
                    name="fileName_display"
                    label={t("text.EnterFileName", "Selected File")}
                    value={fileNameWithoutExt}
                    onChange={(e) => {
                      let input = e.target.value.trim();
                      const forcedExt = ".pdf";
                      setFileNameWithoutExt(input);
                      setOriginalExtension(forcedExt);
                      setfileName(input + forcedExt);
                    }}
                    size="small"
                    fullWidth
                    InputProps={{
                      endAdornment: originalExtension ? (
                        <InputAdornment
                          position="end"
                          disableTypography
                          sx={{
                            pointerEvents: "none",
                            userSelect: "none",
                            color: "green",
                            fontWeight: "bold"
                          }}
                        >
                          {originalExtension}
                        </InputAdornment>
                      ) : null,
                    }}
                    InputLabelProps={{
                      shrink: Boolean(fileNameWithoutExt || originalExtension),
                    }}
                    error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
                    helperText={
                      fileName && !fileName.toLowerCase().endsWith(".pdf")
                        ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
                        : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
                    }
                  />
                </Grid>

                <Grid item lg={1.5} xs={12}>
                  <Button
                    startIcon={<AddCircleIcon />}
                    variant="contained"
                    fullWidth
                    onClick={addMoreRow}
                    disabled={!fileName || !pDate}
                  >
                    {t("text.add")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {tableData.length > 0 && (
                  <Grid item xs={12} sx={{ marginTop: "15px", overflowX: "auto" }}>
                    <Table
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        border: "1px solid #ddd",
                      }}
                      size="small"
                    >
                      <thead style={{ backgroundColor: "#e0e0e0" }}>
                        <tr>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.Action", "Action")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.PeriodDate", "Period Date")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.Keywords", "Keywords")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.FileName", "File Name")}
                          </th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                            {t("text.PdfFile", "PDF File")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.map((row: any) => (
                          <tr key={row.id}>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              <DeleteIcon
                                style={{ color: "darkred", cursor: "pointer" }}
                                onClick={() => removeExtraRow(row.id)}
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              {row.pDate ? moment(row.pDate).format("DD-MM-YYYY") : "-"}
                            </td>
                            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                              {row.keywords || "-"}
                            </td>
                            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                              {row.pdfName}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              {row.pdfView ? (
                                <Typography
                                  onClick={() => modalOpenHandle1(row.pdfView)}
                                  sx={{
                                    color: "primary.main",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {t("text.Preview", "Preview")}
                                </Typography>
                              ) : (
                                t("text.NoPreview", "No Preview")
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Grid>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                container
                spacing={2}
                justifyContent="center"
                sx={{ mt: 2 }}
              >
                <Grid item xs={6}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: `var(--header-background)` }}
                  >
                    {t("text.update")}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: "#F43F5E" }}
                    onClick={handleReset}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>

          <Modal open={Opens} onClose={handlePanClose1}>
            <Box sx={style}>
              {Img ? (
                <embed
                  src={Img}
                  type="application/pdf"
                  style={{ width: "100%", height: "100%" }}
                />
              ) : (
                <img src={nopdf} style={{ width: "100%" }} />
              )}
            </Box>
          </Modal>
        </CardContent>
      </div>
    </div>
  );
};

export default DocumentEntryEdit;
